import { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PCMP_DISBURSE_VERIFY_PENDING_TAB } from '../../types/pcmpDisburseVerify.types';
import type { PcmpPayoutAcks } from '../../types/pcmpProposal.types';
import { PcmpVerifyDisbursementDialog } from './PcmpVerifyDisbursementDialog';

interface PcmpVerifyDisbursementButtonProps {
  proposalId: number;
  refNo: string;
  payout: PcmpPayoutAcks;
  /** The API's canVerifyDisbursement; false hides the button. */
  canVerify: boolean;
}

/** MIS / Admin's Verify of one proposal's payout. */
export function PcmpVerifyDisbursementButton({
  proposalId,
  refNo,
  payout,
  canVerify,
}: PcmpVerifyDisbursementButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  if (!canVerify) return null;

  // Only an Accounts payout carries a confirmation: that picks the Pending tab
  // (the API goes by who paid it out, not the current payment source).
  const channel = payout.confirmation ? 'ACCOUNTS' : 'MARKETING';

  return (
    <>
      <Button type="button" size="sm" onClick={() => setIsOpen(true)} className="gap-1.5">
        <ShieldCheck className="size-3.5" />
        Verify Disbursement
      </Button>
      {isOpen ? (
        <PcmpVerifyDisbursementDialog
          target={{
            tab: PCMP_DISBURSE_VERIFY_PENDING_TAB[channel],
            selection: { proposalIds: [proposalId] },
            count: 1,
            refNo,
          }}
          onClose={() => setIsOpen(false)}
        />
      ) : null}
    </>
  );
}
